import Formatter from './Formatter';
import {LOAN_IN_REPAYMENT_STATUSES} from './AnalysisTools';
export const getWeightedInterestRate=(loans)=>
{
    let balance=loans.map(loan=>Formatter.moneyToNumber(loan.loan_amount)).reduce((total,amount)=>total+amount,0);
    if(balance===0)
        return 0;
    let interest=loans.filter(loan=>Formatter.moneyToNumber(loan.loan_outstanding_principal_balance)>0).map(loan=>Formatter.moneyToNumber(loan.loan_amount)*(parseFloat(Formatter.moneyToNumber(loan.loan_interest))/100)).reduce((total,amount)=>total+amount,0);

    return roundDecimalsUp((interest*100)/balance);
}
export const roundDecimalsUp=(value)=>
{
    let pieces=value.toString().split('.');
    if(pieces.length==1||pieces[1].length<=2)
        return value;
    else
    {
        let decimals=parseInt(pieces[1].substring(0,2));
        let roundFactor=parseInt(pieces[1].substring(2,3));
        if(roundFactor===0)
            return parseFloat(`${pieces[0]}.${decimals}`);
        else
        {
            decimals++;
            return decimals<100?parseFloat(`${pieces[0]}.${decimals}`):parseFloat(pieces[0])+1;
        }

    }
    
}
export const parseLoan = (loan) => {
    return {
        balance: Formatter.moneyToNumber(loan.loan_outstanding_principal_balance),
        rate: Formatter.moneyToNumber(loan.loan_interest),
        mmp: Formatter.moneyToNumber(loan.loan_repayment_plan_scheduled_amount),
        repayment: loan.loan_status.length > 0 && loan.loan_status[0].status && (loan.loan_status[0].status.toUpperCase() === "DA" || LOAN_IN_REPAYMENT_STATUSES.includes(loan.loan_status[0].status.toUpperCase()))
    };
}
export default {
    roundDecimalsUp,
    getWeightedInterestRate,
    parseLoan
}